export default {
	styleOverrides: {
		root: {
			top: '-4px',
			color: '#858585',
			fontSize: '16px',
			lineHeight: '160%',
			letterSpacing: '0.15px',
			'&.Mui-error': {
				color: '#858585',
			},
		},
		shrink: {
			transform: 'translate(14px, -5px) scale(0.75)',
		},
	},
};
